import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useStoresByOnwer } from '../../../hooks/owner/allStores.owner';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import StoreBox from '../../../components/store/StoreBox';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

function OnwerViewAllStores() {
    const {t} = useTranslation();
    const {data:stores,isLoading,isError,} = useStoresByOnwer();
    const {accessToken,store} = useSelector((s:RootState)=>s.store);
  return (
    <Layout title={t("layout_titles.stores")} headline={t('stores_headline',{num:stores?.stores.length})}>
      <div className="flex justify-between items-center">
  <div></div>

      <div className="flex items-center gap-3">
        {/* Hint – show only when condition is true */}
        {stores?.hasIncompleteStore && (
          <span className="text-sm text-yellow-600 bg-yellow-100 px-3 py-1 rounded-lg border border-yellow-200">
            {t('hasIncompleteStore')}
          </span>
        )}

        <PrimaryButtonWithIconAdd
          buttonLabel="add_new_store"
          buttonLinkPath="/owner/add-store"
        />
      </div>
    </div>

      {!accessToken && (
      <div className="flex flex-col items-center justify-center p-6 bg-LightGrey1 border-2 border-dashed border-DarkGrey1 rounded-xl text-center mt-4">
        {t('no_store_selected')}
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
        </h2>
        <p className="text-gray-500 mb-4">
          {t('select_store_hint')}
        </p>
      </div>
    )}

      <div className=' mt-8'>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        errorMessage="some thing wrong happened"
        type="grid"
      />
      </div>
      {
        (stores && stores.stores.length>0) &&
        <div className='grid md:grid-cols-2 xl:grid-cols-3 gap-8 mt-8'>
          {
            stores.stores.map(st=>{
            return <StoreBox store={st} key={st.id+"jn"} showSelect={store?store.id===st.id:false}/>
          })
          }
        </div>
      }
    </Layout>
  )
}

export default OnwerViewAllStores